import { app } from './src/index';

app(); 